import styled from '@emotion/styled/macro';
import { Variables } from '../base';

export const Card = styled.section`
    display: flex;
    overflow: hidden;
    border: 1px solid ${Variables.ThemeLight.Border2};
    border-radius: 10px;
    background: ${Variables.ThemeLight.Background3};
`;

export const AccentBar = styled.div<{ $color: string }>`
    flex: none;
    width: 4px;
    background: ${({ $color }) => $color};
`;

export const Layout = styled.div`
    display: grid;
    flex: 1;
    grid-template-columns: minmax(0, 1.55fr) minmax(280px, 0.95fr);
    align-items: stretch;

    @media (max-width: 900px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

export const Primary = styled.div`
    display: flex;
    flex-direction: column;
    gap: 9px;
    padding: 18px 22px 20px;
`;

export const Eyebrow = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 11px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.TextMild};
`;

export const PillRow = styled.span`
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    align-self: flex-start;
`;

export const Headline = styled.h3`
    margin: 0;
    font-family: ${Variables.Fonts.calibre};
    font-size: 26px;
    font-weight: 600;
    line-height: 1.15;
    color: ${Variables.ThemeLight.TextStrong};
    text-wrap: pretty;
`;

export const Detail = styled.p`
    margin: 0;
    max-width: 620px;
    font-family: ${Variables.Fonts.calibre};
    font-size: 15px;
    line-height: 1.4;
    color: ${Variables.ThemeLight.TextMedium};
    text-wrap: pretty;
`;

export const ReworkReason = styled.p`
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0;
    font-family: ${Variables.Fonts.calibre};
    font-size: 13px;
    font-weight: 600;
    color: ${Variables.ThemeLight.AttentionInverted3};

    svg {
        flex: none;
        fill: currentColor;
    }
`;

export const Meta = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 18px 22px 20px;
    border-left: 1px solid ${Variables.ThemeLight.Border2};

    @media (max-width: 900px) {
        border-left: none;
        border-top: 1px solid ${Variables.ThemeLight.Border2};
    }
`;

export const MetaCellRoot = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
`;

export const MetaLabel = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 10px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.TextMild};
`;

export const MetaValue = styled.span<{ $code?: boolean }>`
    font-family: ${Variables.Fonts.calibre};
    font-size: ${({ $code }) => ($code ? 12 : 14)}px;
    font-weight: ${({ $code }) => ($code ? 400 : 600)};
    line-height: 1.3;
    color: ${({ $code }) => ($code ? Variables.ThemeLight.TextMedium : Variables.ThemeLight.TextStrong)};
    font-variant-numeric: tabular-nums;
    overflow-wrap: anywhere;
    text-wrap: pretty;
`;
